/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserAvatar_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UpdateViewerAvatarModal_user$ref: FragmentReference;
declare export opaque type UpdateViewerAvatarModal_user$fragmentType: UpdateViewerAvatarModal_user$ref;
export type UpdateViewerAvatarModal_user = {|
  +id: string,
  +avatar: ?string,
  +firstName: string,
  +$fragmentRefs: UserAvatar_user$ref,
  +$refType: UpdateViewerAvatarModal_user$ref,
|};
export type UpdateViewerAvatarModal_user$data = UpdateViewerAvatarModal_user;
export type UpdateViewerAvatarModal_user$key = {
  +$data?: UpdateViewerAvatarModal_user$data,
  +$fragmentRefs: UpdateViewerAvatarModal_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UpdateViewerAvatarModal_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "avatar",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserAvatar_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '8df50ad3db3f0e48ea5196aca6bd5295';
module.exports = node;
